import { useState, useRef } from "react";
import axios from "axios";
import { API, api, authHeaders } from "@/lib/galleryApi";

const CHUNK = 8 * 1024 * 1024;

// Resumable upload: each 8 MB piece is retried, and the server offset is re-read after a failure
export function useChunkedUpload() {
  const [progress, setProgress] = useState(null);
  const cancelled = useRef(false);

  const send = async (up, file) => {
    let offset = up.received || 0;
    while (offset < file.size) {
      if (cancelled.current) throw new Error("Import annule");
      const piece = file.slice(offset, offset + CHUNK);
      let ok = false;
      for (let attempt = 0; attempt < 5 && !ok; attempt++) {
        try {
          const r = await axios.put(`${API}/api/gallery-restore/uploads/${up.id}/chunk?offset=${offset}`, piece, { headers: { ...authHeaders(), "Content-Type": "application/octet-stream" } });
          offset = r.data.received;
          ok = true;
        } catch (e) {
          const s = await api.get(`/gallery-restore/uploads/${up.id}`).catch(() => null);
          if (s && s.received !== offset) { offset = s.received; ok = true; }
          else await new Promise((res) => setTimeout(res, 1500 * (attempt + 1)));
        }
      }
      if (!ok) throw new Error("Connexion interrompue : relancez l'import, il reprendra ou il s'est arrete");
      setProgress({ sent: offset, total: file.size });
    }
  };

  const upload = async (file, galleryId) => {
    cancelled.current = false;
    setProgress({ sent: 0, total: file.size });
    const up = await api.post("/gallery-restore/uploads", { filename: file.name, size: file.size, gallery_id: galleryId });
    await send(up, file);
    return up;
  };

  return { upload, progress, cancel: () => { cancelled.current = true; } };
}
